'use client';

import Image from 'next/image';
import { useTranslation } from '@/hooks/useTranslations';
import './InsideShiftSection.scss';

export default function InsideShiftSection() {
  const { t } = useTranslation();

  return (
    <section
      className="inside-shift-section"
      aria-labelledby="inside-shift-section-title"
    >
      <div className="inside-shift-section__inner">
        <div className="inside-shift-section__header">
          <p className="inside-shift-section__label">{t('insideShift.label')}</p>

          <h2 className="inside-shift-section__title">
            {t('insideShift.titleLine1')}
            <br />
            {t('insideShift.titleLine2')}
          </h2>

          <p className="inside-shift-section__subtitle">
            {t('insideShift.subtitle')}
          </p>
        </div>

        <div className="inside-shift-section__cards">
          <Image
            src="/shift-applications.png"
            alt={t('insideShift.cards.applications.alt')}
            width={305}
            height={389}
            className="inside-shift-section__card-image"
          />
          <Image
            src="/shift-messaging.png"
            alt={t('insideShift.cards.messaging.alt')}
            width={305}
            height={389}
            className="inside-shift-section__card-image"
          />
          <Image
            src="/shift-contract.png"
            alt={t('insideShift.cards.contracts.alt')}
            width={305}
            height={389}
            className="inside-shift-section__card-image"
          />
          <Image
            src="/shift-compliance.png"
            alt={t('insideShift.cards.compliance.alt')}
            width={305}
            height={389}
            className="inside-shift-section__card-image"
          />
        </div>
      </div>
    </section>
  );
}
